<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >
    <b-row>
      <b-col cols="12">
        <b-card class="">
          <b-row>
            <b-col cols="12" md="4">
              <b-button
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  class="col-12 col-md-5"
                  variant="primary"
                  @click="renderCreateModal"
              >
                Add Video Sitemap
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-card no-body>
          <h4 class="m-2">list</h4>
          <b-table
              ref="refUserListTable"
              :fields="myTableColumns"
              :items="pageData"
              :sort-by.sync="sortBy"
              bordered
              class="position-relative"
              empty-text="Nothing found!"
              primary-key="id"
              responsive
              show-empty
              striped
          >
            <template #cell(id)="data">
              <a target="_blank">
                <span class="text-muted ml-2">#{{ data.item.id }}</span>
              </a>
            </template>

            <template #cell(operation)="data">
              <b-button
                  class="font-bold p-0 text-white bg-primary my-btn p-25"
                  size="sm"
                  type="button"
                  variant="primary"
                  @click="renderEditModal(data.item)"
              >
                Edit
              </b-button>
            </template>

            <template #cell(delete)="data">
              <b-button
                  class="font-bold p-0 text-white bg-primary my-btn p-25"
                  size="sm"
                  type="button"
                  variant="danger"
                  @click="renderDeleteModal(data.item)"
              >
                Delete
              </b-button>
            </template>
          </b-table>
          <div class="mx-2 mb-2">
            <b-row>
              <!-- Pagination -->
              <b-col
                  class="d-flex align-items-center justify-content-between flex-wrap flex-md-nowrap"
                  cols="12"
                  sm="12"
              >
                <b-pagination
                    v-model="currentPage"
                    :per-page="count"
                    :total-rows="totalCount"
                    class="mb-2 mb-md-0 mt-1 mt-sm-0"
                    first-number
                    last-number
                    next-class="next-item"
                    prev-class="prev-item"
                >
                  <template #prev-text>
                    <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                    />
                  </template>
                </b-pagination>

                <b-col
                    class="d-flex align-items-center justify-content-start justify-content-md-end mb-2 mb-md-0"
                    cols="12"
                    md="2"
                >
                  <label>Count</label>
                  <v-select
                      v-model="count"
                      :clearable="false"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="perPageOptions"
                      class="per-page-selector d-inline-block mx-50 w-50"
                  />
                </b-col>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
        id="modal-create"
        cancelTitle="Cancel"
        centered
        no-close-on-backdrop
        ok-title="Add"
        title="Add Video Sitemap"
        @cancel="closeCreateModal"
        @ok="addVideoSitemap"
    >
      <validation-observer
          ref="refFormObserver"
      >
        <b-form-group
            class="mt-2"
            label="pageUrl"
        >
          <validation-provider
              #default="{ errors }"
              rules="required"
          >
            <b-form-input
                v-model="newVideoSiteMap.pageUrl"
                :state="errors.length > 0 ? false:null"
            ></b-form-input>
          </validation-provider>
        </b-form-group>
        <b-form-group
            class="mt-2"
            label="videoTitle"
        >
          <validation-provider
              #default="{ errors }"
              rules="required"
          >
            <b-form-input
                v-model="newVideoSiteMap.videoTitle"
                :state="errors.length > 0 ? false:null"
            ></b-form-input>
          </validation-provider>
        </b-form-group>
        <b-form-group
            class="mt-2"
            label="videoDescription"
        >
          <validation-provider
              #default="{ errors }"
              rules="required"
          >
            <b-form-input
                v-model="newVideoSiteMap.videoDescription"
                :state="errors.length > 0 ? false:null"
            ></b-form-input>
          </validation-provider>
        </b-form-group>
        <b-form-group
            class="mt-2"
            label="videoUrl"
        >
          <validation-provider
              #default="{ errors }"
              rules="required"
          >
            <b-form-input
                v-model="newVideoSiteMap.videoUrl"
                :state="errors.length > 0 ? false:null"
            ></b-form-input>
          </validation-provider>
        </b-form-group>
        <b-form-group
            class="mt-2"
            label="videoThumbnail"
        >
          <b-form-input
              v-model="newVideoSiteMap.videoThumbnail"
          ></b-form-input>
        </b-form-group>
      </validation-observer>
    </b-modal>

    <b-modal
        id="modal-edit"
        cancelTitle="Cancel"
        centered
        no-close-on-backdrop
        ok-title="Edit"
        title="Edit Video Sitemap"
        @cancel="closeEditModal"
        @ok="updateData()"
    >
      <b-form-group
          class="mt-2"
          label="pageUrl"
      >
        <b-form-input
            v-model="selectedToEdit.pageUrl"
        ></b-form-input>
      </b-form-group>
      <b-form-group
          class="mt-2"
          label="videoTitle"
      >
        <b-form-input
            v-model="selectedToEdit.videoTitle"
        ></b-form-input>
      </b-form-group>
      <b-form-group
          class="mt-2"
          label="videoDescription"
      >
        <b-form-input
            v-model="selectedToEdit.videoDescription"
        ></b-form-input>
      </b-form-group>
      <b-form-group
          class="mt-2"
          label="videoUrl"
      >
        <b-form-input
            v-model="selectedToEdit.videoUrl"
        ></b-form-input>
      </b-form-group>
      <b-form-group
          class="mt-2"
          label="videoThumbnail"
      >
        <b-form-input
            v-model="selectedToEdit.videoThumbnail"
        ></b-form-input>
      </b-form-group>
    </b-modal>

    <b-modal
        id="modal-delete"
        cancelTitle="Cancel"
        centered
        ok-title="Delete"
        @ok="deleteData()"
    >
      <span>Are you sure?</span>
    </b-modal>

  </b-overlay>
</template>

<script>
import {
  BAlert,
  BAvatar,
  BButton,
  BCard,
  BCardBody,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BImg,
  BLink,
  BMedia,
  BModal,
  BOverlay,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs
} from 'bootstrap-vue'
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import Helper from "@/libs/Helper";
import {required} from '@validations';
import LanguagePicker from "@/views/components/utils/LanguagePicker.vue";
import AddEditDeleteButton from "@/views/components/utils/AddEditDeleteButton.vue";
import {GetAllLangs} from "@/libs/Api/Language";
import {ShipmentDelete, ShipmentGetBy} from "@/libs/Api/Shipment";
import {
  VideoSiteMapsCreate,
  VideoSiteMapsDelete,
  VideoSiteMapsGetAll,
  VideoSiteMapsUpdate
} from "@/libs/Api/VideoSitemap";

export default {
  title: 'Video sitemap',
  data() {
    return {
      required,
      languageList: [],
      overlay: false,
      pageData: [],
      newVideoSiteMap: {
        pageUrl: '',
        videoUrl: '',
        videoTitle: '',
        videoDescription: '',
        videoThumbnail: '',
      },
      perPageOptions: [10, 20, 30, 40, 50],
      currentPage: 1,
      sortBy: '',
      count: 10,
      totalCount: null,
      selectedToDelete: null,
      selectedToEdit: {},
      myTableColumns: [
        {
          key: 'id',
          label: 'Id',
          sortable: true
        },
        {
          key: 'pageUrl',
          label: 'pageUrl',
          sortable: true
        },
        {
          key: 'videoUrl',
          label: 'videoUrl',
          sortable: true
        },
        {
          key: 'videoTitle',
          label: 'videoTitle',
          sortable: true
        },
        {
          key: 'videoDescription',
          label: 'videoDescription',
          sortable: true
        },
        {
          key: 'operation',
          label: 'Edit'
        },
        {
          key: 'delete',
          label: 'Delete'
        },
      ],
      selectedDataId: null,
    }
  },
  async created() {
    await this.getData();
  },
  watch: {
    currentPage: function (nv, ov) {
      this.getData();
    },
    count: function (nv, ov) {
      this.getData();
    },
  },
  methods: {
    async getData() {
      let _this = this;
      _this.overlay = true;

      let data = {
        PageNumber: _this.currentPage,
        Count: _this.count,
      }

      let videoSiteMapsGetAll = new VideoSiteMapsGetAll(_this);
      videoSiteMapsGetAll.setParams(data);
      await videoSiteMapsGetAll.fetch(function (content) {
        _this.overlay = false;
        _this.pageData = content.data.date;
        _this.totalCount = content.data.totalCount;
      }, function (error) {
        _this.overlay = false;
        console.log(error)
      })
    },
    async addVideoSitemap() {
      let _this = this;
      Helper.validateForm(_this, 'refFormObserver', async () => {
        _this.overlay = true;

        let videoSiteMapsCreate = new VideoSiteMapsCreate(_this);
        videoSiteMapsCreate.setParams(_this.newVideoSiteMap);
        await videoSiteMapsCreate.fetch((content) => {
          _this.overlay = false;
          _this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              title: `Operation successful`,
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          window.location.reload();
        }, (error) => {
          _this.overlay = false;
          console.log(error)
        });
      })
    },
    async updateData() {
      let _this = this;
      _this.showOverlay = true;

      let videoSiteMapsUpdate = new VideoSiteMapsUpdate(_this);
      videoSiteMapsUpdate.setParams(_this.selectedToEdit);
      await videoSiteMapsUpdate.fetch(function (content) {
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `Operation successful`,
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        _this.showOverlay = false;
        _this.selectedToEdit = {};
        _this.getData();
      }, function (error) {
        _this.showOverlay = false;
        console.log(error)
      })
    },
    async deleteData() {
      let _this = this;
      _this.overlay = true;

      let videoSiteMapsDelete = new VideoSiteMapsDelete(_this);
      videoSiteMapsDelete.setParams({id:this.selectedToDelete.id});
      await videoSiteMapsDelete.fetch(function (content) {
        _this.overlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `Operation successful`,
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        _this.selectedToDelete = null;
        _this.getData();
      }, function (error) {
        _this.overlay = false;
        console.log(error)
      })
    },
    generateObjectForAddEditRemoveButton(data) {
      return {
        id: data.id,
        languageId: data.languageId,
        otherLanguages: data.otherLanguages || [],
        mainId: data.mainId,
      };
    },
    renderDeleteModal(data) {
      this.selectedToDelete = JSON.parse(JSON.stringify(data));
      this.$bvModal.show("modal-delete");
    },
    async renderEditModal(data) {
      this.selectedToEdit = JSON.parse(JSON.stringify(data));
      setTimeout(() => {
        this.$bvModal.show("modal-edit");
      }, 500)
    },
    renderCreateModal(data) {
      this.$bvModal.show("modal-create");
    },
    async getShipment(id) {
      let _this = this;
      _this.showOverlay = true;

      let shipmentGetBy = new ShipmentGetBy(_this);
      shipmentGetBy.setParams({id: id})
      await shipmentGetBy.fetch((content) => {
        _this.showOverlay = false;
        _this.selectedToEdit = content.data.data;
      }, (e) => {
        _this.showOverlay = false;
        console.log(e)
      })
    },
    async getAllLanguages() {
      try {
        let requestParams = {
          count: 100,
          pageNumber: 1,
        };
        if (this.searchCommand) {
          requestParams["searchCommand"] = this.searchCommand;
        }
        this.isLoading = true;
        let _this = this;
        let getAllLangs = new GetAllLangs(_this);

        getAllLangs.setRequestParam(requestParams);
        await getAllLangs.fetch((response) => {
          if (response.isSuccess) {
            _this.languageList = response.data.languages;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    clickOnInput(id) {
      let input = document.getElementById(id);
      input.click();
    },
    setLanguageId(language) {
      this.shipment.languageId = language.languageId;
    },
    closeCreateModal() {
      this.shipment = {
        id: null,
        languageId: null,
        mainId: null,
        name: null,
      };
    },
    closeEditModal() {
      this.selectedToEdit = {};
    }
  },
  components: {
    AddEditDeleteButton,
    LanguagePicker,
    BModal,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BImg,
    BCardText,
    BLink,
    BButton,
    BDropdown,
    BDropdownItem,
    BAlert,
    BTab,
    BTabs,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BMedia,
    BAvatar,
    BOverlay,
    vSelect,
    BTable,
    BPagination,
    ValidationObserver, ValidationProvider,
  },
}
</script>

<style>
.modal-header > .close {
  display: none !important;
}
</style>